import { ChangePasswordComponent } from '../../../../login/src/lib/components/change-password/change-password.component';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from '@ebw-monorepo/utils';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChangePasswordService {
  private url_get: string = '';
  private url_change_password: string = '';

  constructor(private utilsSrv: UtilsService, public dialog: MatDialog) {}

  private getUser(token: string) {
    let api_url = this.getUrlGet();
    api_url += '?tokens=' + token;
    return this.utilsSrv.getRequest(api_url, {});
  }

  control(token: string) {
    if (this.url_get.length !== 0) {
      this.getUser(token).subscribe({
        next: (res) => {
          if (res.error == 0 && res.data && res.data.length > 0) {
            let data = res.data[0];
            if (!data.credentials.validated) {
              const dialogRef = this.dialog.open(ChangePasswordComponent, {
                disableClose: true,
                hasBackdrop: true,
                data: {
                  url: this.url_change_password,
                  user_id: data.properties.id,
                  expiredDate: data.properties.expired
                },
                height: '50%'
              });

              // dialogRef.afterClosed().subscribe({
              //   next: (resp) => {
              //     if (!resp) {
              //       router.navigate(["login"]);
              //     }
              //   },
              //   error: (e) => console.error(e)
              // })
            }
          }
        },
        error: (e) => {
          console.error(e);
        }
      });
    }
  }

  getUrlGet() {
    return this.url_get;
  }

  setUrlGet(url: string) {
    this.url_get = url;
  }

  getUrlChangePassword() {
    return this.url_change_password;
  }

  setUrlChangePassword(url: string) {
    this.url_change_password = url;
  }
}
